// Backend taban adresi çözümleyici.
// Önizleme ve canlı ortamda /api istekleri her zaman bulunulan origin'e yönlenir.
// Derlemeye gömülen adres eski ya da farklı bir domain'e işaret ediyorsa
// (ör. eski bir dağıtım domain'i), bunun yerine bulunulan origin kullanılır.
const resolveBase = () => {
  const env = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  if (typeof window === "undefined" || !window.location) return env;
  const { origin, hostname, host } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") return env || origin;
  if (env) {
    try {
      if (new URL(env).host === host) return env;
    } catch {
      return env;
    }
  }
  return origin;
};

export const BACKEND_URL = resolveBase();
export const API = `${BACKEND_URL}/api`;
